import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {},
  copyButton: {
    fontSize: 14,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: '400 !important',
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
})

const TextCopy = ({
  classes, className, text, onCopy
}) => {
  function onTextClick() {
    navigator.clipboard.writeText(text)

    if (onCopy) {
      onCopy(text)
    }
  }
  return (
    <Typography className={classNames(classes.root, className)}>
      {text}
      <span className={classes.copyButton} onClick={onTextClick}>
        Copy
      </span>
    </Typography>
  )
}

TextCopy.propTypes = {
  text: PropTypes.string,
  onCopy: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(TextCopy)



// WEBPACK FOOTER //
// ./src/components/atoms/TextCopy.js